import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const TrashcanFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.42 19.84L6.06 6.46H3.72V4.92H8.3V3.88C8.3 2.76 9.18 1.84 10.48 1.84H13.52C14.82 1.84 15.7 2.76 15.7 3.88V4.92H20.28V6.46H17.94L17.58 19.84H6.42ZM10.06 4.06V4.92H13.94V4.06C13.94 3.66 13.6 3.32 13.2 3.32H10.8C10.4 3.32 10.06 3.66 10.06 4.06ZM9.58 17.22H11.08V7.54H9.58V17.22ZM12.92 17.22H14.42V7.54H12.92V17.22Z" />
    </SvgIcon>
  );
});
